import React, { Component } from "react"
import {
  Button,
  Checkbox,
  Col,
  ConfigProvider,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Tabs,
  Spin,
  message,
} from "antd"
import zhCN from "antd/lib/locale/zh_CN"
import style from "./App.module.css"
import PropTypes from "prop-types"
import {
  AlipayCircleOutlined,
  GithubOutlined,
  LockTwoTone,
  MailTwoTone,
  MobileTwoTone,
  TaobaoCircleOutlined,
  UserOutlined,
  WeiboCircleOutlined,
} from "@ant-design/icons"
import { loginAction, loginGetVerification } from "../../store/actionCreators"
import { connect } from "react-redux"
import { postAction } from "../../utils/request"

const { TabPane } = Tabs

const menu = (
  <Menu>
    <Menu.Item>
      <span>🇺🇸 English</span>
    </Menu.Item>
    <Menu.Item>
      <span>🇵🇱 Bahasa Indonesia</span>
    </Menu.Item>
    <Menu.Item>
      <span>🇧🇷 Português</span>
    </Menu.Item>
    <Menu.Item>
      <span>🇨🇳 简体中文</span>
    </Menu.Item>
    <Menu.Item>
      <span>🇭🇰 繁体中文</span>
    </Menu.Item>
  </Menu>
)
const layout = {
  wrapperCol: {
    span: 24,
  },
}

class App extends Component {
  constructor() {
    super()
    this.state = {
      timer: "",
      counter: 0,
      showCounter: false,
      haveVerification: false,
      tabIndex: "1",
      form: React.createRef(),
    }
  }

  componentDidMount() {
    if (this.props.loginState) {
      this.props.history.replace("/home")
    }
  }

  render() {
    return (
      <div>
        {this.props.loadingState && (
          <div className={style.loadingBox}>
            <Spin className={style.loadingImg} />
          </div>
        )}
        <ConfigProvider locale={zhCN}>
          <div className={style.app}>
            <div className={style.top}>
              <Dropdown overlay={menu}>
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <span className={style.topIcon}>
                    <img
                      className={style.svg}
                      src="https://fycoder.oss-cn-hangzhou.aliyuncs.com/web/react-login/language.png"
                      alt=""
                    />
                  </span>
                </a>
              </Dropdown>
            </div>
            <div className={style.center}>
              <div>
                <div style={{ width: "100%", height: "44px" }}>
                  <a href="https://preview.pro.ant.design/dashboard/analysis">
                    <img
                      className={style.titleImg}
                      src="https://preview.pro.ant.design/static/logo.f0355d39.svg"
                      alt=""
                    />
                    <span className={style.titleSpan}>Ant Design</span>
                  </a>
                </div>
                <div className={style.desc}>
                  Ant Design 是西湖区最具影响力的 Web 设计规范
                </div>
              </div>
              <div className={style.main}>
                <Form
                  {...layout}
                  name="basic"
                  initialValues={{
                    remember: true,
                  }}
                  ref={this.state.form}
                  onFinish={(e) => this.handleLoginClick(e)}
                >
                  <Tabs
                    defaultActiveKey="1"
                    onChange={(e) => this.setState({ tabIndex: e })}
                  >
                    <TabPane tab="账户密码登录" key="1">
                      <div>
                        <Form.Item
                          name="username"
                          rules={
                            this.state.tabIndex === "1"
                              ? [
                                  {
                                    required: true,
                                    message: "请输入用户名！",
                                  },
                                ]
                              : []
                          }
                        >
                          <Input
                            size="large"
                            placeholder="用户名: admin or user"
                            prefix={
                              <UserOutlined
                                style={{ color: "#4091f7" }}
                                className="inputIcon"
                              />
                            }
                          />
                        </Form.Item>

                        <Form.Item
                          name="password"
                          rules={
                            this.state.tabIndex === "1"
                              ? [
                                  {
                                    required: true,
                                    message: "请输入密码！",
                                  },
                                ]
                              : []
                          }
                        >
                          <Input.Password
                            size="large"
                            placeholder="密码: ant.design"
                            prefix={<LockTwoTone className="inputIcon" />}
                            visibilityToggle={false}
                          />
                        </Form.Item>
                      </div>
                    </TabPane>
                    <TabPane tab="手机号登录" key="2">
                      <div>
                        <Form.Item
                          name="mobilePhone"
                          rules={
                            this.state.tabIndex === "2"
                              ? [
                                  {
                                    required: true,
                                    message: "请输入手机号！",
                                  },
                                  {
                                    validator: this.handleValidator,
                                    message: "手机号格式错误!",
                                  },
                                ]
                              : []
                          }
                        >
                          <Input
                            size="large"
                            placeholder="手机号"
                            prefix={<MobileTwoTone className="inputIcon" />}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ marginBottom: "24px", height: "40px" }}
                          name="message"
                          rules={
                            this.state.tabIndex === "2"
                              ? [
                                  {
                                    required: true,
                                    message: "请输入验证码！",
                                  },
                                ]
                              : []
                          }
                        >
                          <Row>
                            <Col
                              flex={1}
                              style={{
                                float: "left",
                                marginRight: "8px",
                              }}
                            >
                              <Input
                                size="large"
                                placeholder="验证码"
                                prefix={<MailTwoTone className="inputIcon" />}
                              />
                            </Col>

                            {this.state.showCounter ? (
                              <Col>
                                <Button size="large" disabled>
                                  {this.state.counter}秒后重新获取
                                </Button>
                              </Col>
                            ) : (
                              <Col span={8} style={{ float: "right" }}>
                                <Button
                                  style={{
                                    width: "100%",
                                    padding: "6.4px 15px",
                                  }}
                                  size="large"
                                  onClick={() => this.getVerification()}
                                >
                                  获取验证码
                                </Button>
                              </Col>
                            )}
                          </Row>
                        </Form.Item>
                      </div>
                    </TabPane>
                  </Tabs>
                  <div>
                    <Checkbox>自动登录</Checkbox>
                    <a style={{ float: "right" }}>忘记密码</a>
                  </div>
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      style={{ width: "100%", marginTop: "24px" }}
                      htmlType="submit"
                    >
                      登录
                    </Button>
                    <div className={style.otherWay}>
                      其他登录方式
                      <AlipayCircleOutlined className={style.span} />
                      <TaobaoCircleOutlined className={style.span} />
                      <WeiboCircleOutlined className={style.span} />
                      <a
                        href="https://preview.pro.ant.design/user/register/"
                        style={{ color: "#4091f7", float: "right" }}
                      >
                        注册账户
                      </a>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            </div>
            <div className="footer">
              <div className={style.footerTextBox}>
                <div style={{ marginBottom: "8px" }}>
                  <a
                    title="Ant Design Pro"
                    target="_blank"
                    rel="noreferrer"
                    href="https://pro.ant.design"
                    style={{
                      marginRight: "40px",
                      color: "rgba(0, 0, 0, 0.45)",
                    }}
                  >
                    Ant Design Pro
                  </a>
                  <a
                    title="github"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      marginRight: "40px",
                      color: "rgba(0, 0, 0, 0.45)",
                    }}
                    href="https://github.com/ant-design/ant-design-pro"
                  >
                    <GithubOutlined />
                  </a>
                  <a
                    title="Ant Design"
                    target="_blank"
                    rel="noreferrer"
                    href="https://ant.design"
                    style={{ color: "rgba(0, 0, 0, 0.45)" }}
                  >
                    Ant Design
                  </a>
                </div>
                <div className="texts">
                  Copyright&copy;2019 蚂蚁金服体验技术部出品
                </div>
              </div>
            </div>
          </div>
        </ConfigProvider>
      </div>
    )
  }

  //获取验证码
  getVerification() {
    this.state.form.current
      .validateFields(["mobilePhone"])
      .then(() => {
        let promise = new Promise((resolve) => {
          setTimeout(() => {
            resolve("验证码为123456")
          }, 2000)
        }).then((res) => {
          message.success(res)
          this.startCounter()
          this.setState({
            haveVerification: true,
          })
        })
        this.props.getVerification(promise)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  //开始倒计时
  startCounter() {
    this.setState({
      showCounter: true,
      counter: 60,
    })
    let timer = setInterval(() => {
      if (this.state.counter > 0) {
        this.setState({
          counter: this.state.counter - 1,
        })
      } else this.clearCounter()
    }, 1000)
    this.setState({
      timer,
    })
  }

  //清除倒计时
  clearCounter() {
    this.setState({
      counter: 0,
      showCounter: false,
    })
    clearInterval(this.state.timer)
  }

  handleLogin(parameter) {
    return postAction("system/login", parameter).then(
      (res) => {
        if (res.result === "success") {
          //将登录状态保存在本地
          let localStorage = window.localStorage
          localStorage.token = res.message.token
          localStorage.hasLogin = "1"
          message.success("登录成功！")
          this.clearCounter() //清除登录页倒计时
          setTimeout(() => this.props.history.replace("/home"), 50) //登录成功但是token更新有时有延迟，进行延时处理
          return Promise.resolve(res.message.token)
        } else {
          message.error(res.code)
          return Promise.reject(res.code)
        }
      },
      () => {
        message.error("网络异常")
      }
    )
  }

  handleLoginClick(e) {
    if (this.state.tabIndex === "1") {
      //用户名密码登录
      let promise = this.handleLogin({
        password: e.password,
        userName: e.username,
      })
      this.props.login(promise)
    } else {
      if (this.state.haveVerification) {
        let promise = this.handleLogin({ userName: "lyc", password: e.message })
        this.props.login(promise)
      } else {
        message.error("请先获取验证码")
      }
    }
  }

  handleValidator(rule, val, callback) {
    //验证手机号
    if (!val) {
      callback()
    }
    const myReg = /^[1][3,4,5,7,8][0-9]{9}$/
    const validateResult = myReg.test(val) // 自定义规则
    if (!validateResult) {
      callback("手机号格式错误！")
      return
    }
    callback()
  }
}

App.propTypes = {
  history: PropTypes.object.isRequired,
  loginState: PropTypes.bool.isRequired,
  counter: PropTypes.number.isRequired,
  loadingState: PropTypes.bool.isRequired,
  loginHaveVerification: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  getVerification: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  loginState: state.loginState,
  counter: state.loginCounter,
  loadingState: state.loginLoading,
  loginHaveVerification: state.loginHaveVerification,
})

const mapDispatchToProps = (dispatch) => ({
  login: (promise) => {
    dispatch(loginAction(promise))
  },
  getVerification: (promise) => {
    dispatch(loginGetVerification(promise))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
